import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { urls } from '../urls';
import { DataService } from '../data.service';
import { GoogleAnalyticsServiceService } from '../google-analytics-service.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  description: string;
}
@Component({
  selector: 'app-product-sourcing-detail',
  templateUrl: './product-sourcing-detail.component.html',
  styleUrls: ['./product-sourcing-detail.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})



export class ProductSourcingDetailComponent implements OnInit {

  // dataSource3 = ELEMENT_DATA;
  dataSource: Array<any> = [];
  expandedElement: any | null;
  sortAscending = true;


  isToggled = false;
  ToggleimageSource: string = '../assets/img/plusToggle.svg';

  toggleChange() {
    this.isToggled = !this.isToggled;
    console.log()
    this.ToggleimageSource = this.isToggled ? '../assets/img/minusToggle.svg' : '../assets/img/plusToggle.svg';

  }

  displayColumns: Array<string> = ['Supplier Id/Name', 'Address', 'City', 'EmailId', 'Contact', 'Pickup Warehouse City', 'LastTransactionDate', 'LastTP', 'CreditDays', 'CountOfTransaction', 'DebitBalance'];
  dataSource2: Array<any> = [];
  displayColumns2: Array<string> = ['TimeAndDate', 'CPONo', 'ProductName', 'Pickup Warehouse City', 'ContactPerson', 'TP', 'SP', 'PaymentType', 'MRN', 'LeadTime', 'DeliveryType']; productId: string;
  msnDetails: any;
  supplierDetails: any
  image: string;
  sortedCategoryHierarchy: { key: string; value: any; }[];
  categoryId: any;
  orderBy: string = 'desc';
  pageNo: number = 0;
  pageSize: number = 10;
  warehouseDetails: any[];
  selectedWarehouseIds: string[] = [];
  warehouseIDs: any;
  creditTermDetailsMap = new Map;
  dataload: boolean;
  countToStop: boolean = false;
  isFullListDisplayed: boolean = false;
  searchCategoryID: any;
  searchOpenString: any;
  brandIDs: any;
  sor: string
  supplierTransactionDetails: any;
  showSupplierName: string;
  supplierId: any;
  panelOpenState: boolean = true;
  expandedRow: any | null = null;
  showFullAddress: boolean = false;

  constructor(private analyticsService: GoogleAnalyticsServiceService, private router: Router, private paramRoute: ActivatedRoute, private service: DataService, private dataService: DataService, private snackBar: MatSnackBar) {

  }

  ngOnInit(): void {

    this.analyticsService.trackPageView('/supplier-discovery');
    this.paramRoute.queryParams.subscribe(params => {
      this.productId = params['productId'];
      this.searchCategoryID = params['category'];
      this.searchOpenString = params['searchStr'] == undefined ? '' : params['searchStr'];
      this.brandIDs = params['brandIds'];
      this.sor = params['sor'];
    });
    this.getSupplierDetails();
    if (this.productId != null)
      this.getMsnDetails();
    this.image = urls.s3Link;
  }
  toggleAddress() {
    this.showFullAddress = !this.showFullAddress;
  }
  processSupplierWareHouse(data) {
    this.service.offSpinner()
    if (data.status) {
      this.warehouseDetails = data.data;
    } else {
      this.service.showMessage('error', data.message);
    }
  }

  toggleSort() {
    this.sortAscending = !this.sortAscending;

    this.service.onSpinner()
    let body = {
      "warehouseIds": this.selectedWarehouseIds
    }

    if (this.orderBy == 'desc') {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
    let url = urls.supplierDetails + "?productId=" + this.productId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;

    this.service.callRestful('POST', url, body, null, null, null).subscribe(this.processSupplierResult.bind(this));
    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Discovery", JSON.stringify(body), "/supplier-discovery");

  }

  productDiscovery() {
    // const searchOpenString = localStorage.getItem('page1slectedopenString');
    // let searchCategoryID = localStorage.getItem('page1slectedCategory');
    // const brandIDs = localStorage.getItem('page1slectedbrandIds');


    localStorage.setItem('status', "true");
    // if (data['status'] && data.data.products.length != 0) {
    //   this.searchedData=data.data;
    // this.dataService.emitSearchFilterChange(data);

    // if (!this.searchCategoryID) {
    //   this.paramRoute.queryParams.subscribe(params => {
    //     this.searchCategoryID = params['category'];
    //   });
    // }
    const queryParams: any = {};
    if (this.searchCategoryID) {
      queryParams.category = this.searchCategoryID;
    }
    if (this.brandIDs && this.brandIDs.length > 0) {
      queryParams.brandIds = this.brandIDs;
    }

    if (this.searchOpenString) {
      queryParams.searchStr = this.searchOpenString;
    }
    queryParams.sor = queryParams.sor = this.sor ? this.sor : "CIS";
    this.router.navigate(['/product-discovery'], { queryParams });
    // } else {
    //   this.requestOpen = {};
    //   this.dataService.offSpinner()
    //   this.router.navigateByUrl('/no-result-found');

    // }


    // if (searchOpenString != undefined && searchOpenString.length != 0 && searchCategoryID == undefined && brandIDs == undefined)
    //   this.router.navigateByUrl('/product-discovery?searchStr=' + searchOpenString);
    // else if (searchCategoryID != undefined && (searchOpenString == undefined || searchOpenString.length == 0) && brandIDs == undefined)
    //   this.router.navigateByUrl('/product-discovery?category=' + searchCategoryID);
    // else if (searchCategoryID != undefined && searchOpenString != undefined && searchOpenString.length != 0 && brandIDs == undefined)
    //   this.router.navigateByUrl('/product-discovery?category=' + searchCategoryID + "&searchStr=" + searchOpenString);
    // else if (brandIDs.length != 0 && searchCategoryID == undefined && (searchOpenString == undefined || searchOpenString.length == 0))
    //   this.router.navigateByUrl('/product-discovery?brandIds=' + brandIDs);
    // else if (searchCategoryID != undefined && searchOpenString != undefined && searchOpenString.length != 0 && brandIDs.length != 0)
    //   this.router.navigateByUrl('/product-discovery?category=' + searchCategoryID + "&searchStr=" + searchOpenString + "&brandIds=" + brandIDs)
    // else if (searchCategoryID != undefined && brandIDs.length != 0 && (searchOpenString == undefined))
    //   this.router.navigateByUrl('/product-discovery?category=' + searchCategoryID + "&brandIds=" + brandIDs);
    // else if (brandIDs.length != 0 && searchOpenString != undefined && searchOpenString.length != 0 && searchCategoryID == undefined)
    //   this.router.navigateByUrl('/product-discovery?brandIds=' + brandIDs + "&searchStr=" + searchOpenString);
    // else
    //   this.router.navigateByUrl('/product-discovery');

  }


  getMsnDetails(): any {
    this.service.onSpinner()
    let url = urls.msnDetails + this.productId;

    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processResult.bind(this));
    // this.dataService.eventTracker("CIS-PORTAL", "PDP-Page", "", "/product-detail");
  }
  processResult(data) {
    this.service.offSpinner()
    if (data.status) {
      this.msnDetails = data;
      localStorage.setItem("supplierCategory", this.msnDetails?.categoryCodeList[0])
      this.breadCrumDataBy(this.msnDetails?.categoryCodeList[0])
    }
    else {
      this.service.showMessage('error', data.message);
    }

  }


  getCategoryImage(): string {


    if (this.msnDetails?.imagesUrls != null && this.msnDetails?.imagesUrls[0])
      return this.image + this.msnDetails?.imagesUrls[0];
    else
      return "https://catalog-dev.moglilabs.com/assets/img/NoImg.png"
  }


  breadCrumDataBy(categoryId: String): Promise<any> {
    if (categoryId) {
      return new Promise<any>((resolve, reject) => {
        this.service.getBreadCrumData(categoryId).subscribe(
          (data) => {
            const categoryIdHirarchy = data['categoryHierarchy'];
            this.sortedCategoryHierarchy = Object.keys(categoryIdHirarchy)
              .filter((key) => key.startsWith('category_name_level') && categoryIdHirarchy[key] !== null)
              .sort()
              .map((key) => ({ key: key, value: categoryIdHirarchy[key] }));

            // Get the value of 'category_name' and append it to the sortedCategoryHierarchy array
            const category_name = categoryIdHirarchy['category_name'];
            if (category_name) {
              this.sortedCategoryHierarchy.push({ key: 'category_name', value: category_name });
            }

            resolve(this.sortedCategoryHierarchy);
          },
          (error) => {
            // Handle error if necessary
            console.error(error);
            reject(error);
          }
        );
      });
    }
  }



  getSupplierDetails(): any {
    this.service.onSpinner()
    let body = {
      "warehouseIds": this.selectedWarehouseIds
    }
    let url = urls.supplierDetails + "?productId=" + this.productId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;

    this.service.callRestful('POST', url, body, null, null, null).subscribe(this.processSupplierResult.bind(this));
    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Discovery", JSON.stringify(body), "/supplier-discovery");
  }

  processSupplierResult(data) {
    this.service.offSpinner()
    if (data.status) {
      this.dataload = true
      this.supplierDetails = data.data['supplierDetails'];
      this.dataSource = data.data['supplierDetails'];
      if (this.warehouseDetails == undefined || this.warehouseDetails.length == 0)
        this.warehouseDetails = data.data['warehouseDetails'];
      this.creditTermDetailsMap = data.data['creditTermDetails']
      if (this.dataSource.length < this.pageSize)
        this.countToStop = false
      else
        this.countToStop = true
    } else {
      this.service.showMessage('error', data.message);
      this.dataload = false
    }
    this.dataload = false
  }


  getSupplierTransactionDetails(supplierId: string) {
    this.service.onSpinner()
    let url = urls.supplierTransaction + "?msn=" + this.productId + "&supplierId=" + supplierId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy= desc";
    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processSupplierResultData.bind(this));
    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Details", "", "/supplier-details");
  }

  processSupplierResultData(data) {
    this.panelOpenState = true;
    this.service.offSpinner()
    if (data.status) {
      this.supplierTransactionDetails = data.data;
      this.dataSource2 = data.data;
    } else {
      this.service.showMessage('error', data.message);
    }
  }


  supplierPage(supplierId) {

    const queryParams: any = {};
    if (this.searchCategoryID) {
      queryParams.category = this.searchCategoryID;
    }
    if (this.brandIDs && this.brandIDs.length > 0) {
      queryParams.brandIds = this.brandIDs;
    }

    if (this.searchOpenString) {
      queryParams.searchStr = this.searchOpenString;
    }
    if (this.productId) {
      queryParams.productId = this.productId;
    }
    if (supplierId) {
      queryParams.supplierId = supplierId;
    }
    if (this.sor) {
      queryParams.sor = this.sor;
    }

    this.router.navigate(['/supplier-details'], { queryParams });


    // this.router.navigateByUrl('/supplier-details?category=' + this.categoryId + '&productId=' + this.productId + '&supplierId=' + supplierId);
  }

  onWareHouseSelectionChange(warehouseDetail: any, isChecked: boolean) {

    if (isChecked) {
      this.selectedWarehouseIds.push(warehouseDetail.warehouseId);

    } else {
      const index = this.selectedWarehouseIds.indexOf(warehouseDetail.warehouseId);
      if (index !== -1) {
        this.selectedWarehouseIds.splice(index, 1);
      }
    }
  }

  warehouseClick() {

    if (this.selectedWarehouseIds.length == 0) {
      this.service.showMessage('error', "Please select pickup warehouse city ");
      return;
    }
    this.service.onSpinner()
    let body = {
      "warehouseIds": this.selectedWarehouseIds
    }
    let url = urls.supplierDetails + "?productId=" + this.productId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;


    this.service.callRestful('POST', url, body, null, null, null).subscribe(this.processSupplierResult.bind(this));

    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Discovery", JSON.stringify(body), "/supplier-discovery");


  }

  clearWarehouseClick() {


    if (this.selectedWarehouseIds.length == 0) {
      return;
    }
    this.selectedWarehouseIds = []
    this.warehouseDetails.forEach(warehouseDetail => {
      warehouseDetail.checked = false;
    });


    this.service.onSpinner()
    let body = {
      "warehouseIds": this.selectedWarehouseIds
    }
    let url = urls.supplierDetails + "?productId=" + this.productId + "&pageNo=0&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;

    this.warehouseDetails.forEach(warehouseDetail => {
      if (this.selectedWarehouseIds.includes(warehouseDetail.warehouseId)) {
        warehouseDetail.checked = true;
      }

    });



    this.service.callRestful('POST', url, body, null, null, null).subscribe(this.processSupplierResult.bind(this));

    this.dataService.eventTracker("CIS-PORTAL", "Supplier-Discovery", JSON.stringify(body), "/supplier-discovery");
  }

  // Event handler for open filter change
  onCategoryFilterChange(categoryName: string) {
  }


  onBrandFilterChange(brandFilterValue: any[]) {
  }


  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {
  }
  onSearchFilterChange(searchFilterChange: string) {
  }

  onScroll() {
    try {

      if (this.dataSource.length > 1 && this.countToStop) {
        // this.loadingMoreData = true;
        this.pageSize += 1;
        let body = {
          "warehouseIds": this.selectedWarehouseIds
        }
        let url = urls.supplierDetails + "?productId=" + this.productId + "&pageNo=" + this.pageNo + "&pageSize=" + this.pageSize + "&orderBy=" + this.orderBy;
        this.service.showMessage('success', "Data Loading...")
        this.service.callRestful('POST', url, body, null, null, null, false).subscribe(this.processSupplierResult.bind(this));
        this.dataService.eventTracker("CIS-PORTAL", "Supplier-Discovery", JSON.stringify(body), "/supplier-discovery");
      } else {
        this.isFullListDisplayed = true;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //this.loadingMoreData = false;
      // this.dataLoaded = true;
    }
  }

  truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + '...';
    }
    return text;
  }

 copyToClipboard(text: string, tooltip: MatTooltip): void {
  navigator.clipboard.writeText(text).then(() => {
    const originalMessage = tooltip.message;
    tooltip.message = 'Copied!';
    tooltip.show();
    
    setTimeout(() => {
      tooltip.hide();
      tooltip.message = originalMessage;
    }, 500);
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
}
}
const ELEMENT_DATA: PeriodicElement[] = [
  {
    position: 1,
    name: 'Hydrogen',
    weight: 1.0079,
    symbol: 'H',
    description: `Hydrogen is a chemical element with symbol H and atomic number 1. With a standard
        atomic weight of 1.008, hydrogen is the lightest element on the periodic table.`
  }, {
    position: 2,
    name: 'Helium',
    weight: 4.0026,
    symbol: 'He',
    description: `Helium is a chemical element with symbol He and atomic number 2. It is a
        colorless, odorless, tasteless, non-toxic, inert, monatomic gas, the first in the noble gas
        group in the periodic table. Its boiling point is the lowest among all the elements.`
  }, {
    position: 3,
    name: 'Lithium',
    weight: 6.941,
    symbol: 'Li',
    description: `Lithium is a chemical element with symbol Li and atomic number 3. It is a soft,
        silvery-white alkali metal. Under standard conditions, it is the lightest metal and the
        lightest solid element.`
  }, {
    position: 4,
    name: 'Beryllium',
    weight: 9.0122,
    symbol: 'Be',
    description: `Beryllium is a chemical element with symbol Be and atomic number 4. It is a
        relatively rare element in the universe, usually occurring as a product of the spallation of
        larger atomic nuclei that have collided with cosmic rays.`
  }, {
    position: 5,
    name: 'Boron',
    weight: 10.811,
    symbol: 'B',
    description: `Boron is a chemical element with symbol B and atomic number 5. Produced entirely
        by cosmic ray spallation and supernovae and not by stellar nucleosynthesis, it is a
        low-abundance element in the Solar system and in the Earth's crust.`
  }, {
    position: 6,
    name: 'Carbon',
    weight: 12.0107,
    symbol: 'C',
    description: `Carbon is a chemical element with symbol C and atomic number 6. It is nonmetallic
        and tetravalent—making four electrons available to form covalent chemical bonds. It belongs
        to group 14 of the periodic table.`
  }, {
    position: 7,
    name: 'Nitrogen',
    weight: 14.0067,
    symbol: 'N',
    description: `Nitrogen is a chemical element with symbol N and atomic number 7. It was first
        discovered and isolated by Scottish physician Daniel Rutherford in 1772.`
  }, {
    position: 8,
    name: 'Oxygen',
    weight: 15.9994,
    symbol: 'O',
    description: `Oxygen is a chemical element with symbol O and atomic number 8. It is a member of
         the chalcogen group on the periodic table, a highly reactive nonmetal, and an oxidizing
         agent that readily forms oxides with most elements as well as with other compounds.`
  }, {
    position: 9,
    name: 'Fluorine',
    weight: 18.9984,
    symbol: 'F',
    description: `Fluorine is a chemical element with symbol F and atomic number 9. It is the
        lightest halogen and exists as a highly toxic pale yellow diatomic gas at standard
        conditions.`
  }, {
    position: 10,
    name: 'Neon',
    weight: 20.1797,
    symbol: 'Ne',
    description: `Neon is a chemical element with symbol Ne and atomic number 10. It is a noble gas.
        Neon is a colorless, odorless, inert monatomic gas under standard conditions, with about
        two-thirds the density of air.`
  },
];


